export default "__VITE_ASSET__DtFnaRSc__"